import { getUserInfo } from "@/lib/api/client-authentication";
import { Star } from "lucide-react"
import { useState } from "react";



// import { useAuthContext } from "../../../providers/auth_provider";




type Props = {
	onCreate: any;
};

export default function ReviewForm({ onCreate }: Props) {
	const [show, setShow] = useState(false);
	const [rating, setRating] = useState<number>(1);

	const [review, setReview] = useState<string>();

	const postReview = async () => {
		if (review === undefined || review === '') {
			setShow(false);
			return;
		}

		if (rating === undefined) {
			setRating(1);
		}
		const member = await getUserInfo()
		const newReview = {
			postBy: member.name,
			date: new Date().toISOString().substring(0, 10),
			rating: rating,
			review: review,
		};
		// console.log(newReview);
		onCreate(newReview);

		setReview('');
		setRating(1);
		setShow(false);
	};

	return (
		<>
			{show ? (
				<div className="max-w-lg">
					<textarea
						className="rounded-sm border border-gray-300 px-4 py-3  animated w-full "
						cols={50}
						id="new-review"
						name="comment"
						placeholder="Enter your review here..."
						onChange={(e: any) => setReview(e.target.value)}
						rows={6}
					/>
					<div className="flex justify-end review-form ">
						<div className="rating inline-block text-8xl">
							<input
								className="hidden"
								type="radio"
								value={5}
								onChange={(e: any) => setRating(e.target.value)}
								name="rating"
								id="rating-5"
							/>
							<label htmlFor="rating-5" title="5 stars"
								className="transition-all duration-200 inline-block  m-0 float-right text-black">
								<Star fill="currentColor" height={25} width={25} />
							</label>
							<input
								className="hidden"
								type="radio"
								value={4}
								onChange={(e: any) => setRating(e.target.value)}
								name="rating"
								id="rating-4"
							/>
							<label htmlFor="rating-4" title="4 stars"
								className="transition-all duration-200 inline-block  m-0 float-right text-black">
								<Star fill="currentColor" height={25} width={25} />
							</label>
							<input
								className="hidden"
								type="radio"
								value={3}
								onChange={(e: any) => setRating(e.target.value)}
								name="rating"
								id="rating-3"
							/>
							<label htmlFor="rating-3" title="3 stars"
								className="transition-all duration-200 inline-block  m-0 float-right text-black">
								<Star fill="currentColor" height={25} width={25} />
							</label>
							<input
								className="hidden"
								type="radio"
								value={2}
								onChange={(e: any) => setRating(e.target.value)}
								name="rating"
								id="rating-2"
							/>
							<label htmlFor="rating-2" title="2 stars"
								className="transition-all duration-200 inline-block  m-0 float-right text-black">
								<Star fill="currentColor" height={25} width={25} />
							</label>
							<input
								className="hidden"
								type="radio"
								value={1}
								onChange={(e: any) => setRating(e.target.value)}
								name="rating"
								id="rating-1"
							/>
							<label htmlFor="rating-1" title="1 star"
								className="transition-all duration-200 inline-block  m-0 float-right text-black">
								<Star fill="currentColor" height={25} width={25} />
							</label>
						</div>
					</div>
					<br />
					<div className="text-center flex justify-between ">
						<button
							className="font-medium rounded-sm uppercase text-white px-5 py-2 cursor-pointer bg-red-500"
							onClick={() => {
								setReview('')
								setRating(1)
								setShow(false)
							}}>

							Cancel
						</button>

						<button className="font-medium rounded-sm uppercase text-base px-5 py-2 cursor-pointer bg-green-400 border border-green-400" onClick={postReview}>
							Post Review
						</button>
					</div>
				</div>
			) : (
				<div className="mt-3 flex justify-center">
					<button
						className="font-medium rounded-sm uppercase text-base px-5 py-2 cursor-pointer bg-green-400 border border-green-400 max-h-10"
						onClick={() => setShow(true)}>
						Leave a Review
					</button>
				</div>
			)}
		</>
	);

}
